import React from 'react';
import Home from './pages/home/Home.js';
import Waitlist from './pages/waitlist/Waitlist.js';
import ClientInformation from './pages/clientInformation/ClientInformation.js';
import ClientInformationClasses from './pages/clientInformation/ClientInformationClasses.js';
import WhoIsCheckingIn from './pages/whoIsCheckingIn/WhoIsCheckingIn.js';
import ClientForm from './pages/clientForm/ClientForm.js';
import Services from './pages/services/Services.js';
import Summary from './pages/summary/Summary.js';
import Confirmation from './pages/confirmation/Confirmation.js';
import ConfirmationClasses from './pages/confirmation/ConfirmationClasses.js';
import ClientPersonSelection from './pages/clientPersonSelection/ClientPersonSelection.js';
import Bookings from './pages/bookings/Bookings.js';
import Classes from './pages/classes/Classes.js';
import StaffSelection from './pages/staffSelection/StaffSelection';
import ClientFormSecondary from './pages/clientForm/ClientFormSecondary.js';
import NewFamilyMemberForm from './pages/clientForm/NewFamilyMemberForm.js';
import ClientSelection from './pages/clientSelection/ClientSelection.js';

export const routes = [
  { path: '/', component: Home, exact: true, depth: 0 },
  { path: '/waitlist', component: Waitlist, depth: 1 },
  { path: '/clientInformation', component: ClientInformation, depth: 1 },
  { path: '/clientSelection', component: ClientSelection, depth: 2 },
  { path: '/clientCheckin', render: () => <ClientInformation isCheckingIn={true}/>, depth: 1 },
  { path: '/classCheckin', render: () => <ClientInformationClasses isCheckingIn={true}/>, depth: 1 },
  { path: '/whoIsCheckingIn', component: WhoIsCheckingIn, depth: 2 },
  { path: '/clientPersonSelection', component: ClientPersonSelection, depth: 3 },
  { path: '/newFamilyMember', component: NewFamilyMemberForm, depth: 10 },
  { path: '/clientForm', component: ClientForm, depth: 50 },
  { path: '/services/:personNumber', component: Services, depth: 100 },
  { path: '/bookings', component: Bookings, depth: 100 },
  { path: '/classes', component: Classes, depth: 100 },
  { path: '/clientFormSecondary', component: ClientFormSecondary, depth: 120 },
  { path: '/staffSelection', component: StaffSelection, depth: 150 },
  { path: '/summary', component: Summary, depth: 200 },
  { path: '/confirmation', component: Confirmation, depth: 300 },
  { path: '/confirmationClasses', component: ConfirmationClasses, depth: 300 },
];
